<div class="toolbar-app-menu-item" matTooltip="{{ appModel?.description }}">
  <div (click)="onAppIconClick()">
    @if (iconSource) {
    <div style="width: 100%; display: flex; justify-content: center">
      <img class="toolbar-app-menu-icon" [src]="iconSource" />
    </div>
    } @if (base64String) {
    <div style="width: 100%; display: flex; justify-content: center">
      <img class="toolbar-app-menu-icon" [src]="base64String" />
    </div>
    }
    <div class="toolbar-app-menu-icon-label">{{ labelText }}</div>
  </div>
</div>
